import authorization from "@/authorization/authorization.js"
import axios from "axios"
import store from "../store"
export default {
  list,
}

async function list(taxid) {
  var payload = {
    taxid: taxid,
    seller_taxid: taxid,
    web_service: "R2",
  }
  var dataEncode = await authorization.encodeData(payload)
  var auth = await authorization.gentoken(taxid)
  var headers = { Authorization: "Bearer " + auth }
  try {
    var call = await axios.post(
      process.env.VUE_APP_CREATE_BILL_API + "get_address_r2",
      { data: dataEncode },
      { headers }
    )
    let check = store.getters.groupService
    let branch = store.getters.groupBranch
    let newBranch = []
    if (call.data.status == "OK") {
      let listBranch = call.data.message
      if (check == true) {
        if (branch.length !== 0) {
          for (var i of branch) {
            for (var j of i.group_branch) {
              let index = listBranch.findIndex(
                (arr) => arr.branchid === j.com_branchid
              )
              if (index > -1) {
                newBranch.push(listBranch[index])
              }
            }
          }
          call.data.message = newBranch
        } else {
          call.data.message = listBranch
        }
        //call.data.message = listBranch  /*Old*/
        return call.data
      } else {
        return call.data
      }
    } else {
      return call.data
    }
  } catch (ex) {
    let result = {
      status: "ER",
      errorMessage: "ระบบไม่สามารถค้นหาสาขาผู้ขายได้ในขณะนี้",
    }
    return result
  }
}
